import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc } from "firebase/firestore"
import { useHistory, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import image from '../../../assets/images/user.png'
import UserSubscriptionTable from '../../../components/table/UserSubscriptionTable.'

const Single = ({user}) => {

  const {customerId} = useParams()


  const [ userData, setUserData ] = useState("")

  // const [ orderData, setOrderData ] = useState([])

  const getCustomer = async() => {

      const docRef = doc(db, "users", customerId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setUserData(docSnap.data())
        // console.log(userData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{
    getCustomer()
  }, [])


  // useEffect(() => {
    
  //   //LISTEN REAL TIME

  //   const orderQuery = async() => {

  //     const orderRef = (collection(db, "order"));
  //     const q = query(orderRef, where("userId", "==", customerId));

  //     const querySnapshot = await getDocs(q);
  //       let list = []
  //     querySnapshot.forEach((doc) => {
  //       // doc.data() is never undefined for query doc snapshots
  //       list.push(doc.data())
  //       // console.log(doc.id, " => ", doc.data());
  //       console.log(list)

  //       setOrderData(list)
  //       // console.log(orderData)
  //     });

  //     // setOrderData(doc.data())
  //     // console.log(orderData)

  //   }
    
  //   orderQuery()   
  // },[])
 

  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 className='title'>Information</h2>
            <div className='item'>
            <img
                src = {userData.userImage ? userData.userImage : image}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
            /> 
              
                <div className="details">
                  <h3 className='itemTitle'>{userData.lastname} {userData.firstname}</h3>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{userData.email}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Phone Number:</span>
                    <span className='itemValue'>{userData.phoneNumber}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{userData.email}</span>
                  </div>
                 
               
                </div>

                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Customer ID:</span>
                    <span className='itemValue'>{userData.customerID}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='itemValue'>{userData.gender}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Age Range:</span>
                    <span className='itemValue'>
                     
                      {
                      userData.ageRange === "firstagerange"
                      ?
                      "18 to 29"
                      :
                      userData.ageRange === "secondagerange"
                      ?
                      "30 to 39"
                      :
                      userData.ageRange === "thirdagerange"
                      ?
                      "40 to 59"
                      :
                      "60 and Above"
                   
                      }

                      </span>
                  </div>
               
                </div>

            </div>
          </div>
          <div>
            {/* <Chart 
              aspect={3/1}
              title = "Customer purchase last 6 months"
            /> */}
          </div>
        </div>
        <div className="bottom">
        <div className='listTitle'>Customer Outlets</div>
          <UserSubscriptionTable
                customerId = {customerId}
          />
        </div>
      </div>
    </div>
  )
}

export default Single